$('.home_slide_coll .product-grid').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 5000,
  arrows: true,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ],
});
$('.cstm_coll_single .product-grid').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  centerPadding: '10%',
  variableWidth: true,
  centerMode: true,
  arrows: true,
  dots: true,
  speed: 300,
  centerPadding: '20px 20px 20px 20px',
  infinite: true,
  autoplaySpeed: 5000,
  autoplay: false,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ],
});

  $(".set > a").on("click", function(e) {
    e.preventDefault();
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".content")
        .slideUp(200);
      $(".set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this)
        .siblings(".content")
        .slideDown(200);
    }
  });



$('.testi_in').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows: true,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ],
});



$(".select_prod").click(function() {
  var is_open = $(this).hasClass("open");
  if (is_open) {
    $(this).removeClass("open");
  } else {
    $(this).addClass("open");
  }
});

$(".select_prod li").click(function(e) {
 let url = $(this).find("a").attr("href") || "";

  url = url.trim().toLowerCase();
  if (url && url != "javascript:void(0);") {
      window.location.href = url;
  } else {
      e.preventDefault();
  }

  var selected_value = $(this).html();
  var first_li = $(".select_prod li:first-child").html();

  $(".select_prod li:first-child").html(selected_value);
  $(this).html(first_li);

});

$(document).mouseup(function(event) {

  var target = event.target;
  var select = $(".select_prod");

  if (!select.is(target) && select.has(target).length === 0) {
    select.removeClass("open");
  }

});

$(document).ready(function(e) {
    //$('.know_more a:contains("Learn More")').text("EXPLORE"); 

    $('#Banner-template--16135274856702__165511896981b0549c .button--primary').click(function(e) {
        e.preventDefault(); // Prevent default anchor click behavior

        // Scroll to the target element smoothly
        $('html, body').animate({
            scrollTop: $('#Slide-template--16135274856702__1654276233a289d8c3-1').offset().top
        }, 800); // Adjust duration as needed
    });

     if ($('body').hasClass('template-index')) {
      // Select the variant dropdown
      var $variantDropdown = $('#template--16135274889470__1653568355377854e7--0');
      
      if ($variantDropdown.length) {
        // Automatically select the first variant
        $variantDropdown.prop('selectedIndex', 0); // Select the first option
        $variantDropdown.trigger('click'); // Trigger the click event to update the product details
      }
    }


  
   // setTimeout(function() {
   //   $('.__horizal-star').after('<div id="customer-review-placeholder">Customer Reviews</div>');
   //   $('#customer-review-placeholder').css('cursor', 'pointer');
   //   $('#customer-review-placeholder').click(function(e) {
   //          e.preventDefault();
   //          var targetOffset = $('#shopify-block-fordeer_product_reviews_ugc_review_box_edTj9b').offset().top;
   //          var targetOffset = $('#shopify-block-d72566b7-dce7-420f-bf08-a203c5a9afb5').offset().top;       
   //          $('html, body').animate({
   //              scrollTop: targetOffset
   //          }, 500);
   //      });
   //  }, 5000); // 5000 milliseconds = 5 seconds

  setTimeout(function() {
    $('.__horizal-star').after('<div id="customer-review-placeholder">Customer Reviews</div>');
    $('#customer-review-placeholder').css('cursor', 'pointer');
    $('#customer-review-placeholder').click(function(e) {
    e.preventDefault();

    // Check for body class and set targetOffset accordingly
    var targetOffset;
    var targetSection;
    
    if ($('body').hasClass('citrus-product')) {
        targetSection = $('#shopify-section-template--16135275184382__1704794861be340913');
    } else if ($('body').hasClass('berry-product')) {
        targetSection = $('#shopify-section-template--16135275151614__170505116143b4a897');
    } else if ($('body').hasClass('tropical-product')) {
        targetSection = $('#shopify-section-template--16135275282686__1723011088965a90f3');
    }

    if (targetSection && targetSection.length) {
        targetOffset = targetSection.offset().top;

        // Scroll to the targetOffset
        $('html, body').animate({
            scrollTop: targetOffset
        }, 500, function() {
            // After scrolling, remove any previously set margin-top
            $('body').css('margin-top', '');

            // Set margin-top based on the height of the target section
            var sectionHeight = targetSection.height();
            $(targetSection).css('margin-top', '125px');
        });
    }
});
   
}, 5000);

  
  $('.header__icon.header__icon--menu').click(function() {
    setTimeout(() => {
    $('.header__icon.header__icon--menu').closest('details').removeAttr('open');
    }, 500)
//   	$('nav.menu-drawer-custom').css('display', 'block');
    $('nav.menu-drawer-custom').slideToggle("slow");

  });


  var els3 = $(".cart-notification__header h2.cart-notification__heading");
  for (var i = 0; i < els3.length ; i++) {
    els3[i].outerHTML = '<p class="cart-notification__heading caption-large text-body" style="font-weight:bold">' + els3[i].innerHTML + '</p>';
  }

  function addLineBreak() {
    if ($(window).width() <= 767) {
      var $heading = $('.banner__heading span');
      if ($heading.length && !$heading.html().includes('<br>')) {
        $heading.html($heading.html().replace('Cool Out.', 'Cool Out.<br/>'));
      }
    }
  }

  // Run the function on initial load
  addLineBreak();

  // Run the function on window resize
  $(window).resize(addLineBreak);

});
